import { render, staticRenderFns } from "./CurrencyBuyDocumentReport.vue?vue&type=template&id=04e9d042&"
import script from "./CurrencyBuyDocumentReport.vue?vue&type=script&lang=js&"
export * from "./CurrencyBuyDocumentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports